import * as ActionTypes from './addPhotos';
import { IMAGES_TO_UPLOAD } from './imagesToUpload';

const initialState = {
  selected: [],
  rejected: 0,
  accepted: 0,
  duplicates: 0,
  loaded: 0,
};

const selectedImages = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SELECTED_FILES:
      let noDuplicates = action.images.filter((i) => {
        return (
          state.selected.findIndex((existing) => {
            return existing.id == i.id && existing.imageID == i.imageID;
          }) < 0
        );
      });
      let duplicates = action.images.length - noDuplicates.length;

      //some sources are coming in with a "dateCreated" others with a "dateTaken"
      var fixedDates = state.selected.concat(noDuplicates).map((image) => {
        image.dateCreated = image.dateCreated
          ? image.dateCreated
          : image.dateTaken;
        return image;
      });

      var sortedPhotos = fixedDates.sort((a, b) => {
        return a.dateCreated > b.dateCreated ? 1 : -1;
      });
      return {
        ...state,
        selected: sortedPhotos,
        accepted: sortedPhotos.length,
        duplicates: state.duplicates + duplicates,
      };

    case ActionTypes.FILES_SELECTED:
      return {
        ...state,
        rejected: state.rejected + action.rejectedCount,
        accepted: state.accepted + action.acceptedCount,
      };

    case ActionTypes.DESELECT_FILE:
      let remaining = state.selected.filter((i) => {
        return i !== action.image;
      });
      return {
        selected: remaining,
        rejected: state.rejected,
        accepted: remaining.length,
        duplicates: state.duplicates,
        loaded: remaining.length,
      };
    case ActionTypes.CLEAR_SELECTED_FILES:
      return initialState;
    case IMAGES_TO_UPLOAD:
      return {
        ...state,
        selected: action.images,
        loaded: action.images.length,
      };

    default:
      return state;
  }
};

export default selectedImages;
